import { render, staticRenderFns } from "./AddRedirectDialog.vue?vue&type=template&id=233606cc&scoped=true&"
import script from "./AddRedirectDialog.vue?vue&type=script&lang=ts&"
export * from "./AddRedirectDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233606cc",
  null
  
)

export default component.exports